import { SET_PROJECT_IS_OPEN } from './constants';

const defaultState = {
    isOpen: true,
};

const projectaddressUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_PROJECT_IS_OPEN:
            return { ...state, isOpen: action.isOpen };


        default:
            return state;
    }
};

export default projectaddressUI;



// WEBPACK FOOTER //
// ./src/containers/Inputs/ProjectAddress/reducer.js